module.exports = __webpack_public_path__ + "img/member.bbd679db.svg";